import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  MenuItem,
  Modal,
  CircularProgress,
} from "@mui/material";

import { useIngresoINMOB } from "../../Services/Inmobiliaria/Ingresos";
import { useIngresoTodosINMOB } from "../../Hook/Inmobiliaria/Ingresos";
import { Input, InputDescripcion, buttonGuardar, Texto, modalStyle, buttonCerrar, buttonCancelar, buttonAtras } from "../../Layouts/CustomStyles";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { formatCLP } from "../FuncionesGenerales/FormatoCLP";

export const EditarIngresoINMOB = ({
  cerrarModal,
  refetchIngresos,
  ingreso,
}) => {
  const { editaringreso, descargarPdfingreso} = useIngresoINMOB();
  const { IngresosCategoriaInmob, contactos } = useIngresoTodosINMOB();
  const [usarContacto, setUsarContacto] = useState(null);
    const [contactoSeleccionado, setContactoSeleccionado] = useState("");
    const [nuevoContacto, setNuevoContacto] = useState({});
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [archivoActual, setArchivoActual] = useState(null);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [configCuotas, setConfigCuotas] = useState({
  cantidad: "",
  interes: 0,
});
  const [form, setForm] = useState({
    fecha_emision: "",
    fecha_pago: "",
    categoria_id: "",
    monto_bruto: "",
    iva: "",
    contacto_id: "",
    monto_neto: "",
    descripcion: "",
    archivo: null,
    estado:""
  });
  const [medioPago, setMedioPago] = useState({
  id: null,
  medio: "",
  banco: "",
  banco_otro: "",
  numero_documento: "",
  monto_pagado: "",
});
     const mediosPago = [
    "Transferencia",
    "Débito",
    "Crédito",
    "Cheque",
    "Efectivo"
];

const bancosChile = [
    "Banco de Chile",
    "Banco Estado",
    "Banco Santander",
    "BCI",
    "Scotiabank",
    "Itaú",
    "Banco Security",
    "Otro"
];
  const [cuotas, setCuotas] = useState([]);

  const handleContacto = (e) => {
  const { name, value } = e.target;
  setNuevoContacto({ ...nuevoContacto, [name]: value });
};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

const medioPagoFinal = {
  ...medioPago,
  banco: medioPago.banco === "Otro"
    ? medioPago.banco_otro
    : medioPago.banco,
  monto_pagado: form.monto_bruto
    ? Number(form.monto_bruto)
    : 0
};
  
 const handleFile = (e) => {
  const file = e.target.files[0];



  if (file instanceof File) {
    setForm((prev) => ({
      ...prev,
      archivo: file,
    }));

    setArchivoActual(null);
  } else {
    console.error("NO es un archivo válido");
  }
};
 
  const handleMontoChange = (field, value) => {
    const raw = value.replace(/\./g, "").replace(/\D/g, "");
    setForm({ ...form, [field]: raw });
  };

  
 useEffect(() => {
  if (!ingreso) return;

  setForm({
    fecha_emision: ingreso.fecha_emision || "",
    fecha_pago: ingreso.fecha_pago || "",
    categoria_id: ingreso.categoria_id || "",
    monto_bruto: ingreso.monto_bruto || "",
    iva: ingreso.iva || "",
    monto_neto: ingreso.monto_neto || "",
    descripcion: ingreso.descripcion || "",
    archivo: null,
    estado:ingreso.estado || "",
  });

   setArchivoActual(ingreso.archivo || null);

  if (ingreso.medios_pago?.length > 0) {
    const mp = ingreso.medios_pago[0];

    setMedioPago({
  id: mp.id,
  medio: mp.medio || "",
  banco: mp.banco || "",
  banco_otro: mp.banco_otro || "",
  numero_documento: mp.numero_documento || "",
  monto_pagado: mp.monto_pagado || "",
});

    setCuotas(mp.cuotas || []);
  }
}, [ingreso]);

useEffect(() => {
  if (!ingreso) return;

  setForm((prev) => ({
    ...prev,
    contacto_id: ingreso.contacto_id || "",
  }));

  setContactoSeleccionado(ingreso.contacto_id || "");

  
  setUsarContacto(ingreso.contacto_id ? "existente" : null);

}, [ingreso]);

useEffect(() => {
  if (usarContacto === "nuevo") {
    setContactoSeleccionado("");
  }

  if (usarContacto === "existente") {
    setNuevoContacto({});
  }
}, [usarContacto]);
  
  const handleCuotaChange = (index, field, value) => {
    const raw = field === "monto_cuota"
      ? value.replace(/\./g, "").replace(/\D/g, "")
      : value;

    const nuevas = cuotas.map((c, i) =>
      i === index ? { ...c, [field]: raw } : c
    );

    setCuotas(nuevas);
  };

  const agregarCuota = () => {
  const next =
    cuotas.length > 0
      ? Math.max(...cuotas.map((c) => c.numero_cuota || 0)) + 1
      : 1;

  setCuotas([
    ...cuotas,
    {
      numero_cuota: next,
      monto_cuota: "",
      interes: 0,
      fecha_emision: "",
      fecha_pago: "",
      id: null 
    },
  ]);
};

const cuotasLimpias = cuotas.map((c) => {
  const { id, ...rest } = c;
  return rest;
});



  const eliminarCuota = (index) => {
    setCuotas(cuotas.filter((_, i) => i !== index));
  };

  const calcularMontos = (formulario) => {
  const bruto = Number(formulario.monto_bruto);
  const iva = Number(formulario.iva);

  if (!bruto) {
    return {
      ...formulario,
      monto_neto: "",
      monto_iva: "",
    };
  }

  if (!iva) {
    return {
      ...formulario,
      monto_neto: bruto,
      monto_iva: 0,
    };
  }

  const neto = bruto / (1 + iva / 100);
  const montoIva = bruto - neto;

  return {
    ...formulario,
    monto_neto: Math.round(neto),
    monto_iva: Math.round(montoIva),
  };
};

 useEffect(() => {
  setForm((prev) => calcularMontos(prev));
}, [form.monto_bruto, form.iva]);


const generarCuotasAutomaticas = () => {
  const cantidad = Number(configCuotas.cantidad);
  const interes = Number(configCuotas.interes);
  const monto = Number(form.monto_bruto);

  if (!cantidad || !monto) {
    alert("Debes ingresar monto y cantidad de cuotas");
    return;
  }

  // 💰 calcular total con interés
  const totalConInteres = monto + (monto * interes) / 100;

  // 💰 dividir en cuotas
  const montoBase = totalConInteres / cantidad;

  let fechaBase = new Date(form.fecha_emision || new Date());

  const nuevasCuotas = [];

  for (let i = 0; i < cantidad; i++) {
    const fecha = new Date(fechaBase);
    fecha.setMonth(fecha.getMonth() + i);

    nuevasCuotas.push({
      numero_cuota: i + 1,
      monto_cuota: Math.round(montoBase),
      interes: interes,
      fecha_emision: fecha.toISOString().split("T")[0],
      fecha_pago: fecha.toISOString().split("T")[0],
    });
  }

  setCuotas(nuevasCuotas);
};


  
 const handleSubmit = async () => {
  if (enviandoAlert) return;

  try {
    setEnviandoAlert(true);

    // 🔴 validación básica
    if (!form.monto_bruto) {
      setAlertMessage("El monto bruto es obligatorio");
      setErrorAlertOpen(true);
      setEnviandoAlert(false);
      return;
    }

    const formFinal = { ...form };

    // 🔹 contacto
    if (usarContacto === "existente" && contactoSeleccionado) {
      formFinal.contacto_id = contactoSeleccionado;
    }

    if (usarContacto === "nuevo") {
      delete formFinal.contacto_id;
    }

    // 🔥 FormData
    const formData = new FormData();

    // 🔹 campos base seguros
    Object.keys(formFinal).forEach((key) => {
      const value = formFinal[key];

      if (
        value !== null &&
        value !== undefined &&
        key !== "archivo"
      ) {
        formData.append(key, value);
      }
    });

    // 🔥 archivo
    if (form.archivo instanceof File) {
      formData.append("archivo", form.archivo);
    }

    // 🔥 nuevo contacto
    if (usarContacto === "nuevo" && nuevoContacto?.nombre) {
      formData.append(
        "nuevo_contacto",
        JSON.stringify(nuevoContacto)
      );
    }

    // 🔹 medio de pago
    if (medioPago.medio && medioPago.banco) {
      formData.append(
        "medio_pago",
        JSON.stringify(medioPagoFinal)
      );
    }

    // 🔹 cuotas (CRUD completo)
    if (Array.isArray(cuotas) && cuotas.length > 0) {
      const cuotasLimpias = cuotas.map((c) => ({
        id: c.id || null,
        numero_cuota: c.numero_cuota,
        monto_cuota: c.monto_cuota
          ? Number(c.monto_cuota)
          : 0,
        interes: c.interes
          ? Number(c.interes)
          : 0,
        fecha_emision: c.fecha_emision || null,
        fecha_pago: c.fecha_pago || null,
      }));

      formData.append(
        "cuotas",
        JSON.stringify(cuotasLimpias)
      );
    }

    // 🔍 debug opcional
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    // 🔥 request backend
    const response = await editaringreso(
      ingreso.id,
      formData
    );

    // 🔹 archivo actualizado
    if (response?.data?.archivo) {
      setArchivoActual(response.data.archivo);
    }

    setAlertMessage(
      "Ingreso actualizado correctamente ✅"
    );
    setSuccessAlertOpen(true);

    refetchIngresos();
    cerrarModal();

  } catch (error) {
    console.error(error);
    setAlertMessage("Error al actualizar");
    setErrorAlertOpen(true);

  } finally {
    setEnviandoAlert(false);
  }
};

console.log(archivoActual)
  return (
    <Box p={3}>
      <Typography variant="h6">Editar Ingreso</Typography>

        
      <Grid container spacing={2} mt={1}>
         <Grid size={12}>
                            <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>
                                < Typography sx={{ ...Texto, mb: 2 }}>Detalle Ingreso </ Typography>
                                <Grid container spacing={2}>
        <Grid size={{xs:12, sm:6}}>
          <TextField
            label="Fecha Emisión"
            type="date"
            name="fecha_emision"
            fullWidth
             sx={Input}
            value={form.fecha_emision}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid size={{xs:12, sm:6}}>
          <TextField
            label="Fecha Pago"
            type="date"
            name="fecha_pago"
             sx={Input}
            fullWidth
            value={form.fecha_pago}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid size={12}>
          <TextField
            select
            label="Categoría"
            name="categoria_id"
             sx={Input}
            fullWidth
            value={form.categoria_id}
            onChange={handleChange}
          >
            {IngresosCategoriaInmob?.length > 0 ? (
              IngresosCategoriaInmob.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.nombre}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No hay categorías</MenuItem>
            )}
          </TextField>
        </Grid>
        <Grid size={12}>
                                  <TextField
                                                  select
                                                  fullWidth
                                                  label="Estado ingreso"
                                                  name="estado"
                                                  sx={Input}
                                                  value={form.estado}
                                                  onChange={handleChange}
                                                  margin="normal"
                                                >
                                                  <MenuItem value="REGISTRADO">registrado</MenuItem>
                                                  <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                                                  <MenuItem value="PROCESO">Proceso</MenuItem>
                                                  <MenuItem value="NO PAGO">No pagado</MenuItem>
                                                  <MenuItem value="PAGADO">Pagado</MenuItem>
                                                  <MenuItem value="ANULADO">Anulado</MenuItem>
                                
                                                </TextField>
                            </Grid>

        <Grid size={12}>
          <TextField
            label="Descripción"
            name="descripcion"
             sx={Input}
            multiline
            rows={3}
            fullWidth
            value={form.descripcion}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Button variant="outlined" component="label">
  Reemplazar archivo
  <input type="file" hidden onChange={handleFile} />
</Button>
      <Box mt={2}>
  <Typography variant="body2">

    Archivo actual:

    </Typography>

  {archivoActual && (
    <Box className="ImagenProductoHome">
      <img
        src={`https://contable.alerama.cl/public/${archivoActual}`}
        alt="archivo"
        title="archivo"
        style={{
          width: "200px",
          borderRadius: "8px",
          marginTop: "10px",
        }}
      />
    </Box>
  )}

  {archivoActual && (
    <a
      href={`https://contable.alerama.cl/public//${archivoActual}`}
      target="_blank"
      rel="noreferrer"
    >
      Ver archivo
    </a>
  )}
</Box>


        </Grid>
      </Grid>
      </Box>
      </Grid>
       <Grid size={12}>
                          <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px', mt:5 }}>
                              < Typography sx={{ ...Texto, mb: 2 }}>Detalle del monto </ Typography>
                              <Grid container spacing={2}>
                                  <Grid size={12}>
                                      <TextField
                                          label="Monto Bruto"
                                          name="monto_bruto"
                                          fullWidth
                                          sx={Input}
                                          value={form.monto_bruto ? formatCLP(form.monto_bruto) : ""}
            onChange={(e) =>
              handleMontoChange("monto_bruto", e.target.value)
            }
                                        
                                      />
                                  </Grid>
      
                                  <Grid size={12}>
                                      <TextField
                                          label="IVA (%)"
                                          name="iva"
                                          fullWidth
                                          value={form.iva}
            onChange={handleChange}
                                          sx={Input}
                                      />
                                  </Grid>
      
                                  <Grid size={12}>
                                      <TextField
  label="Monto Neto"
  name="monto_neto"
  fullWidth
  value={form.monto_neto ? formatCLP(form.monto_neto) : ""}
  InputProps={{
    readOnly: true,
  }}
  sx={Input}
/>
                                  </Grid>
                              </Grid>
                          </Box>
                      </Grid>
      </Grid>

      <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px', mt:5, mb:5 }}>

                        <Typography sx={{ ...Texto, mb: 2 }}>
                            Detalle contacto
                        </Typography>

                       

                         
                                <TextField
                                    select
                                    fullWidth
                                    label="Seleccionar contacto"
                                    value={contactoSeleccionado}
                                    onChange={(e) => {
                                        const id = e.target.value;
                                        setContactoSeleccionado(id);

                                        // 🔥 guardas en form para backend
                                        setForm((prev) => ({
                                            ...prev,
                                            contacto_id: id,
                                        }));
                                        }}
                                    sx={{ ...Input, mb: 2 }}
                                >
                                    {/* 👉 esto debe venir de tu API */}
                                    {contactos?.map((c) => (
                                        <MenuItem key={c.id} value={c.id}>
                                            {c.nombre} - {c.empresa}
                                        </MenuItem>
                                    ))}
                                </TextField>

          

                    </Box>
                </Grid>
                        <Grid size={12}>
                    <Box sx={{ border: '1px solid #919191', p: 3, borderRadius: '10px' }}>
                        < Typography sx={{ ...Texto, mb: 2 }}>Detalle de Pago </ Typography>
                        <Grid container spacing={2}>

    <Grid size={12}>
        <TextField
            select
            label="Medio"
            name="medio"
            fullWidth
             value={medioPago.medio}
            onChange={(e) =>
              setMedioPago({
                ...medioPago,
                medio: e.target.value,
              })
            }
            sx={Input}
        >
            {mediosPago.map((m) => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
        </TextField>
    </Grid>

   <Grid size={12}>
    <TextField
        select
        label="Banco"
        name="banco"
        fullWidth
         value={medioPago.banco}
            onChange={(e) =>
              setMedioPago({ ...medioPago, banco: e.target.value })
            }
        sx={Input}
    >
        {bancosChile.map((b) => (
            <MenuItem key={b} value={b}>
                {b}
            </MenuItem>
        ))}
    </TextField>
</Grid>

{medioPago.banco === "Otro" && (
  <Grid size={12}>
    <TextField
      label="Especifique banco"
      fullWidth
      value={medioPago.banco_otro}
      onChange={(e) =>
        setMedioPago({
          ...medioPago,
          banco_otro: e.target.value,
        })
      }
      sx={Input}
    />
  </Grid>
)}
  

    <Grid size={12}>
        <TextField
            label="N° Documento"
            name="numero_documento"
            fullWidth
             value={medioPago.numero_documento}
            onChange={(e) =>
              setMedioPago({
                ...medioPago,
                numero_documento: e.target.value,
              })
            }
            sx={Input}
        />
    </Grid>

</Grid>
{medioPago.medio === "Crédito" && (
  <>
    <Typography mt={3}>Cuotas</Typography>

    {/* 🔥 CONFIGURACIÓN SOLO SI NO HAY CUOTAS */}
    {cuotas.length === 0 && (
      <Box display="flex" gap={2} mt={2}>
        <TextField
          label="Cantidad cuotas"
          type="number"
          value={configCuotas.cantidad}
          onChange={(e) =>
            setConfigCuotas({
              ...configCuotas,
              cantidad: e.target.value,
            })
          }
          sx={Input}
        />

        <TextField
          label="Interés (%)"
          type="number"
          value={configCuotas.interes}
          onChange={(e) =>
            setConfigCuotas({
              ...configCuotas,
              interes: e.target.value,
            })
          }
          sx={Input}
        />
      </Box>
    )}

    {/* 🔥 BOTÓN AGREGAR (SOLO UNA VEZ) */}
    <Button
      onClick={agregarCuota}
      sx={{ ...buttonAtras, mt: 2 }}
    >
      + Agregar cuota
    </Button>

    {/* 🔥 LISTADO DE CUOTAS */}
    {cuotas.map((c, i) => (
      <Box
        key={c.id ?? i}
        display="flex"
        gap={2}
        mt={2}
        alignItems="center"
      >
        <TextField
          label="N°"
          value={c.numero_cuota}
          sx={Input}
          onChange={(e) =>
            handleCuotaChange(i, "numero_cuota", e.target.value)
          }
        />

        <TextField
          label="Monto"
          value={c.monto_cuota}
          sx={Input}
          onChange={(e) =>
            handleCuotaChange(i, "monto_cuota", e.target.value)
          }
        />

        <TextField
          label="F. Emisión"
          type="date"
          value={c.fecha_emision || ""}
          sx={Input}
          onChange={(e) =>
            handleCuotaChange(i, "fecha_emision", e.target.value)
          }
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="F. Pago"
          type="date"
          value={c.fecha_pago || ""}
          sx={Input}
          onChange={(e) =>
            handleCuotaChange(i, "fecha_pago", e.target.value)
          }
          InputLabelProps={{ shrink: true }}
        />

        <Button
          color="error"
          onClick={() => eliminarCuota(i)}
        >
          Eliminar
        </Button>
      </Box>
    ))}
  </>
)}

                    </Box>
                </Grid>

      

  
     

      <Box mt={3}>
        <Button sx={buttonGuardar} onClick={handleSubmit}>
          Guardar Cambios
        </Button>
      </Box>

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                                 <Box sx={modalStyle}>
                                     <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                                         <IoClose />
                                     </section>
                                     <section style={{ textAlign: "center" }}>
                                         <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                                         <p className="alert-text">{alertMessage}</p>
                                     </section>
                                 </Box>
                             </Modal>
                 
                             <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                                 <Box sx={modalStyle}>
                                     <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                                         <IoClose />
                                     </section>
                                     <section style={{ textAlign: "center" }}>
                                         <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                                         <p className="alert-text">{alertMessage}</p>
                                     </section>
                                 </Box>
                             </Modal>
                 
                             <Modal open={enviandoAlert}>
                                 <Box sx={modalStyle}>
                                     <section style={{ textAlign: "center", padding: "1rem" }}>
                                         <CircularProgress style={{ color: "#2a8d74" }} />
                                         <p className="alert-text">Procesando solicitud...</p>
                                     </section>
                                 </Box>
                             </Modal>
    </Box>
  );
};